export default class ControlVideo {
  constructor() {
    this.classes = {
      pause: 'pause',
      textControl: 'text-control',
    };
  }

  pauseAllVideo($buttonPlayPause, listVideo) {
    listVideo.forEach((_elem, index) => {
      // youtube
      if (typeof listVideo[index].pauseVideo !== 'undefined') {
        listVideo[index].pauseVideo();
      }

      // vimeo
      if (typeof listVideo[index].pause !== 'undefined') {
        listVideo[index].pause();
      }
    });

    if (!$buttonPlayPause.hasClass(this.classes.pause)) {
      // force get variable videoPauseText from global
      /* eslint-disable-next-line */
      $buttonPlayPause.addClass(this.classes.pause).find(`.${this.classes.textControl}`).text(!window.videoPlayText ? 'Play' : window.videoPlayText);
    }
  }

  pauseVideo($buttonPlayPause, videoCurrentId, listVideo) {
    listVideo.forEach((_elem, index) => {
      // youtube
      const videoItemId = $(_elem.$el).attr('id');
      if (typeof listVideo[index].pauseVideo !== 'undefined' && videoItemId === videoCurrentId) {
        listVideo[index].pauseVideo();
      }

      // vimeo
      if (typeof listVideo[index].pause !== 'undefined' && videoItemId === videoCurrentId) {
        listVideo[index].pause();
      }
    });

    if (!$buttonPlayPause.hasClass(this.classes.pause)) {
      // force get variable videoPauseText from global
      /* eslint-disable-next-line */
      $buttonPlayPause.addClass(this.classes.pause).find(`.${this.classes.textControl}`).text(!window.videoPlayText ? 'Play' : window.videoPlayText);
    }
  }

  playVideo($buttonPlayPause, videoCurrentId, listVideo) {
    listVideo.forEach((elm, index) => {
      const videoItemId = $(elm.$el).attr('id');
      // youtube
      if (typeof listVideo[index].playVideo !== 'undefined' && videoItemId === videoCurrentId) {
        listVideo[index].playVideo();
      }

      // vimeo
      if (typeof listVideo[index].play !== 'undefined' && videoItemId === videoCurrentId) {
        listVideo[index].play();
      }
    });

    if ($buttonPlayPause.hasClass(this.classes.pause)) {
      // force get variable videoPauseText from global
      /* eslint-disable-next-line */
      $buttonPlayPause.removeClass(this.classes.pause).find(`.${this.classes.textControl}`).text(!window.videoPauseText ? 'Pause' : window.videoPauseText);
    }
  }
}
